<div style="display: flex; align-items: center;">
    <p *ngIf="recordStart && !hideDuration" style="flex-grow: 1; font-size: 12px; font-weight: 200;">{{label}}</p>

    <ng-container *ngIf="!hideButtons">
        <app-button [fill]="buttonsFill" [disabled]="disabled" [color]="buttonColor" [tooltip]="startRecordingTooltip"  *ngIf="!(audioRecordingService.recordingInProgress$ | async) && !recordStart" [iconName]="startRecordingIcon" (clickEvent)="internalStartRecording()"></app-button>
        <app-button [fill]="buttonsFill" [disabled]="disabled" [color]="buttonColor" [tooltip]="stopRecordingTooltip" *ngIf="recordStart && stopRecordingManually" iconName="player-stop-filled" (clickEvent)="stopRecording(true)"></app-button>
        <app-button [fill]="buttonsFill"
                    *ngIf="enableSettings && !(audioRecordingService.recordingInProgress$ | async) && !recordStart"
                    [color]="buttonColor" tooltip="Paramétrer le micro"
                    iconName="settings"
                    (clickEvent)="openSettings()"></app-button>
    </ng-container>
</div>